import BackHeader from '@ben/orion/back-header';
import Loader from '@ben/orion/loader';
import Typography, { TypographyVariant } from '@ben/orion/typography';
import { Grid, Stack } from '@mantine/core';
import { GroupSidebar } from './group-sidebar';
import { Muted, Page } from './shared';
import { useGroupDetail } from './use-group-detail';
import { PendingChanges } from './pending-changes';
import { RequirementDrawer } from './requirement-drawer';
import { RequirementsSection } from './requirements-section';
import { RunActions } from './run-actions';

/**
 * Group detail screen. Each section calls `useGroupDetail` directly;
 * React Query deduplicates the underlying requests.
 */
const GroupDetailScreen = () => {
  const { isLoading, group, onBack } = useGroupDetail();

  if (isLoading) return <Loader />;
  if (!group) return <Muted>Requirement group not found.</Muted>;

  return (
    <Page $noTopPad>
      <BackHeader title={ancestorPath(group.path)} onBack={onBack} noMargin />
      <Typography variant={TypographyVariant.h1}>{group.name}</Typography>

      <Grid gap="xl">
        <Grid.Col span={{ base: 12, lg: 8 }}>
          <Stack gap="lg">
            <RunActions />
            <PendingChanges />
            <RequirementsSection />
          </Stack>
        </Grid.Col>

        <Grid.Col span={{ base: 12, lg: 4 }}>
          <GroupSidebar />
        </Grid.Col>
      </Grid>

      <RequirementDrawer />
    </Page>
  );
};

export default GroupDetailScreen;

const ancestorPath = (path: string) => {
  const ancestors = path.split(' / ').slice(0, -1);
  return ancestors.length > 0 ? ancestors.join(' / ') : 'Requirements';
};
